import { EVENT_NAMES } from './consts';
import { getCookie } from './cookie';

export function trackVideoItemClick(): void {
    document.querySelectorAll<HTMLElement>('.video-item, .js-video-item').forEach((item) => {
        item.addEventListener('click', (event: Event) => {
            const target = event.currentTarget as HTMLElement;
            const videoId = target.dataset.id;
            const videoName = target.querySelector('[title]')?.getAttribute('title');

            if (videoId && videoName) {
                window.dataLayer.push({
                    event: EVENT_NAMES.GENERIC,
                    event_name: EVENT_NAMES.VIDEO_CLICK,
                    video_name: videoName,
                    video_id: videoId,
                });
            }
        });
    });
}

export function sendGeoEvent() {
    const countryCode = getCookie('coc');

    if (!countryCode) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event_name: 'geo',
        country_code: countryCode,
    });
}
